import http from './http';
import { sysNoticeUrlPrefix } from './prefix';

// 集团-公告创建-更新，发布
export const groupSubmitNotice = (data) => {
  return http({
    url: '/group/notice/save-send',
    method: 'POST',
    data,
    headers: {
      urlPrefix: sysNoticeUrlPrefix,
    },
  });
};

// 集团-公告分页查询
export const groupQueryNotice = (data) => {
  return http({
    url: '/group/notice/page',
    method: 'POST',
    data,
    headers: {
      urlPrefix: sysNoticeUrlPrefix,
    },
  });
};

// 集团-公告详情查询
export const groupQueryNoticeDetail = (id) => {
  return http({
    url: `/group/notice/detail/${id}`,
    method: 'GET',
    headers: {
      urlPrefix: sysNoticeUrlPrefix,
    },
  });
};

// 获取岗位名称
export const queryJobNameList = () => {
  return http({
    url: '/group/notice/job-name-list',
    method: 'GET',
    headers: {
      urlPrefix: sysNoticeUrlPrefix,
    },
  });
};

// 集团-公告已读情况分页查询
export const groupQueryReadedNotice = (data) => {
  return http({
    url: '/group/notice/read/page',
    method: 'POST',
    data,
    headers: {
      urlPrefix: sysNoticeUrlPrefix,
    },
  });
};

// 集团-删除公告
export const fetchDeleteNotice = (id) => {
  return http({
    method: 'DELETE',
    url: `/group/notice/${id}`,
    headers: {
      urlPrefix: sysNoticeUrlPrefix,
    },
  });
};

// 员工-员工公告确认
export const confirmNotice = (data) => {
  return http({
    url: '/employee/notice/confirm',
    method: 'POST',
    data,
    headers: {
      urlPrefix: sysNoticeUrlPrefix,
    },
  });
};

// 员工-公告分页查询
export const queryNoticeList = (data) => {
  return http({
    url: '/employee/notice/page',
    method: 'POST',
    data,
    headers: {
      urlPrefix: sysNoticeUrlPrefix,
    },
  });
};

// 员工-公告详情查询
export const queryNoticeDetail = (id) => {
  return http({
    url: `/employee/notice/group/detail`,
    method: 'GET',
    params: { id },
    headers: {
      urlPrefix: sysNoticeUrlPrefix,
    },
  });
};

// 员工-员工公告弹窗
export const queryNoticeAlert = () => {
  return http({
    url: `/employee/notice/alert-query`,
    method: 'GET',
    headers: {
      urlPrefix: sysNoticeUrlPrefix,
    },
  });
};
